import React from "react";
import { Badge } from "@/components/badge";
import { Button } from "@/components/button";
import { XMarkIcon } from "@heroicons/react/16/solid";

export interface Filter {
  key: string;
  label: string;
  value: string;
}

interface ActiveFiltersProps {
  filters: Filter[];
  onRemoveFilter: (key: string) => void;
  onClearAll: () => void;
  className?: string;
  showClearAll?: boolean;
  emptyMessage?: string;
  labelText?: string;
}

const ActiveFilters: React.FC<ActiveFiltersProps> = ({
  filters,
  onRemoveFilter,
  onClearAll,
  className = "",
  showClearAll = true,
  emptyMessage,
  labelText = "Active filters:",
}) => {
  // Don't render anything if no filters and no empty message
  if (filters.length === 0 && !emptyMessage) {
    return null;
  }

  // Show empty message if no filters
  if (filters.length === 0 && emptyMessage) {
    return (
      <div className={`text-sm text-gray-500 ${className}`}>{emptyMessage}</div>
    );
  }

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-sm text-gray-600">{labelText}</span>
      {filters.map((filter) => (
        <Badge
          key={filter.key}
          className="flex items-center gap-1 bg-blue-100 text-blue-800 cursor-pointer hover:bg-blue-200"
          onClick={() => onRemoveFilter(filter.key)}
        >
          {filter.label}
          <XMarkIcon className="h-3 w-3" />
        </Badge>
      ))}
      {showClearAll && filters.length > 0 && (
        <Button
          onClick={onClearAll}
          className="text-sm text-gray-500 underline bg-transparent border-none shadow-none p-0 h-auto"
        >
          Clear All
        </Button>
      )}
    </div>
  );
};

export default ActiveFilters;
